import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { JwtPayload, jwtDecode } from "jwt-decode";

import './App.css';
import Layout from './Layout';
import DashboardLayout from './DashBoardLayout';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import DashBoardPage from './components/DashBoard';
import SyndicatePage from './components/SyndicatePage';
import UpgradePage from './components/UpgradePage';
import Logout from './components/LogoutPage';
import CheckOut from './components/CheckOutPage';
import SupportPage from './components/SupportPage';
import SelectUserTypePage from './components/selectUserType';
import PicksPalacePage from './components/PicksPalace';
import { useNavigate } from 'react-router-dom';

interface CustomJwtPayload extends JwtPayload {
    username?: string;
    exp?: number; // Expiration time in seconds since epoch
}

// Custom hook for authentication
export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("access_token");
        if (token) {
            try {
                const decoded = jwtDecode<CustomJwtPayload>(token);
                if (decoded.exp && decoded.exp * 1000 > Date.now()) {
                    setIsAuthenticated(true);
                } else {
                    localStorage.removeItem("access_token"); // Clear expired token
                    setIsAuthenticated(false);
                }
            } catch {
                setIsAuthenticated(false);
            }
        } else {
            setIsAuthenticated(false);
        }
        setIsLoading(false); // Mark loading as complete
    }, []);

    return { isAuthenticated, isLoading };
};

// Protected route wrapper
interface ProtectedRouteProps {
    isAuth: boolean;
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAuth, children }) => {
    const navigate = useNavigate();
    console.log("Protective route",isAuth);
    useEffect(()=>{
        !isAuth ? navigate('/login/') : console.log("loads auth");
    },[])
    return isAuth ? <>{children}</> : <></>;
};


function App() {
    const { isAuthenticated: isAuth, isLoading } = useAuth();

    if (isLoading) {
        return (
            <></>
        )
    } else {
        return (
            <Router>
                <Routes>
                    {/* Public Layout */}
                    <Route path="/" element={<Layout />}>
                        <Route index element={<HomePage />} />
                        <Route path="/about/" element={<AboutPage />} />
                        <Route path="/support/" element={<SupportPage />} />

                        <>
                            <Route path="/login/" element={<LoginPage />} />
                            <Route path="/signup/" element={<SignupPage />} />
                        </>

                    </Route>

                    {/* Authenticated Layout */}
                    <Route path="/" element={<DashboardLayout />}>
                        <Route
                            path="/dashboard/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <DashBoardPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/Syndicate/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <SyndicatePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/PicksPalace/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <PicksPalacePage />
                                </ProtectedRoute>
                            }
                        />                        
                        <Route
                            path="/Upgrade/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <UpgradePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/logout/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <Logout />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/checkout/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <CheckOut />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/select-user-type/"
                            element={
                                <ProtectedRoute isAuth={isAuth}>
                                    <SelectUserTypePage />
                                </ProtectedRoute>
                            }
                        />                        
                    </Route>
                </Routes>
            </Router>
        );
    }

}

export default App;
